import React from 'react';
import './Services.css';
import { useLanguage } from '../../../../context/LanguageContext';
import translations from '../../../../translations';

// Import image
import servicesImage from '../../../../assets/background2.webp';

const Services = () => {
  const { language, direction } = useLanguage();
  const t = translations[language];
  const isRTL = direction === 'rtl';

  const services = [
    {
      id: 1,
      title: language === 'en' ? 'General Construction' : 'البناء العام',
      description: language === 'en'
        ? 'Full-scale construction of residential, commercial, and industrial buildings.'
        : 'بناء شامل للمباني السكنية والتجارية والصناعية.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 21h18"></path>
          <path d="M9 8h1"></path>
          <path d="M9 12h1"></path>
          <path d="M9 16h1"></path>
          <path d="M14 8h1"></path>
          <path d="M14 12h1"></path>
          <path d="M14 16h1"></path>
          <path d="M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16"></path>
        </svg>
      )
    },
    {
      id: 2,
      title: language === 'en' ? 'Finishing Works' : 'أعمال التشطيب',
      description: language === 'en'
        ? 'Premium interior and exterior finishing with high-quality materials.'
        : 'تشطيبات داخلية وخارجية فاخرة بمواد عالية الجودة.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M2 22h20"></path>
          <path d="M6.36 17.4 4 17l-2-4 1.1-.55a2 2 0 0 1 1.8 0l.17.1a2 2 0 0 0 1.8 0L8 12l-2-4.5 2.28-.76a2 2 0 0 1 1.64.21l.28.21a2 2 0 0 0 1.64.21L14 6l2.94-2.94a2.5 2.5 0 0 1 3.54 0l.42.42a2.5 2.5 0 0 1 0 3.54l-8.26 13.28a2 2 0 0 1-1.6.7H8.18a2 2 0 0 1-1.82-2.6z"></path>
        </svg>
      )
    },
    {
      id: 3,
      title: language === 'en' ? 'Maintenance' : 'الصيانة',
      description: language === 'en'
        ? 'Comprehensive maintenance services to keep buildings in optimal condition.'
        : 'خدمات صيانة شاملة للحفاظ على المباني بأفضل حالة.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
        </svg>
      )
    },
    {
      id: 4,
      title: language === 'en' ? 'Restoration' : 'الترميم',
      description: language === 'en'
        ? 'Expert restoration and rehabilitation of existing structures.'
        : 'ترميم وإعادة تأهيل المباني القائمة بخبرة عالية.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
          <polyline points="3.29 7 12 12 20.71 7"></polyline>
          <line x1="12" y1="22" x2="12" y2="12"></line>
        </svg>
      )
    },
    {
      id: 5,
      title: language === 'en' ? 'Project Management' : 'إدارة المشاريع',
      description: language === 'en'
        ? 'End-to-end project supervision and management services.'
        : 'إشراف وإدارة شاملة للمشاريع من البداية للنهاية.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
          <rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>
          <path d="M9 14l2 2 4-4"></path>
        </svg>
      )
    },
    {
      id: 6,
      title: language === 'en' ? 'Electromechanical' : 'الأعمال الكهروميكانيكية',
      description: language === 'en'
        ? 'Complete MEP (mechanical, electrical, plumbing) solutions.'
        : 'حلول متكاملة للأعمال الميكانيكية والكهربائية والسباكة.',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>
          <circle cx="19" cy="19" r="2"></circle>
        </svg>
      )
    }
  ];

  return (
    <section className={`services-section ${isRTL ? 'rtl' : ''}`} id="services">
      <div className="services-container">
        <div className="services-header">
          <h2 className="services-title">{t.servicesTitle}</h2>
          <div className="services-divider"></div>
        </div>

        <div className="services-grid">
          {/* Left Side - Service List */}
          <div className="services-content-side">
            <div className="services-list">
              {services.map((service) => (
                <div key={service.id} className="service-item">
                  <div className="service-icon">
                    {service.icon}
                  </div>
                  <div className="service-content">
                    <h3 className="service-title">{service.title}</h3>
                    <p className="service-description">{service.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Side - Image */}
          <div className="services-image-side">
            <div className="services-image-container">
              <img
                src={servicesImage}
                alt={language === 'en' ? 'Our Services' : 'خدماتنا'}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;